import React from 'react';
import {
  Popover,
  Position,
  Menu,
  PopoverInteractionKind,
  Icon
} from "@blueprintjs/core";


class Dropdown extends React.Component {

  state = {width: null};

  componentDidMount() {
    if (this.componentRef) {
      this.setState({width: this.componentRef.clientWidth});
    }
  }

  render() {

    const {menuItems} = this.props;
    const target = <Icon icon="menu" iconSize={20}/>;
    const content = <Menu>{menuItems}</Menu>;

    return (
      <Popover content={content} target={target} minimal
               position={Position.BOTTOM}
               interactionKind={PopoverInteractionKind.CLICK}
      />
    );

  }
}

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/Dropdown/index.js